import _Vue from 'vue';
import ClientsDao from '@/data/dao/ClientsDao';
import BuildingsDao from '@/data/dao/BuildingsDao';
import MetersDao from '@/data/dao/MetersDao';
import DashboardDao from '@/data/dao/DashboardDao';
import LogsDao from "@/data/dao/LogsDao";
import DataloggerDao from "@/data/dao/DataloggerDao";

export function daoInjection(Vue: typeof _Vue): void {
  Vue.prototype.$dao = {
    clients: ClientsDao,
    buildings: BuildingsDao,
    meters: MetersDao,
    dashboard: DashboardDao,
    logs: LogsDao,
    datalogger: DataloggerDao,
  };
}

declare module 'vue/types/vue' {
  interface Vue {
    $dao: {
      clients: typeof ClientsDao;
      buildings: typeof BuildingsDao;
      meters: typeof MetersDao;
      dashboard: typeof DashboardDao;
      logs: typeof LogsDao;
      datalogger: typeof DataloggerDao;
    };
  }
}
